<template>
  <div id="app">
    <router-view/>
    <div id="modals">
     <component v-for="(modal, i) in modals" :is="modal.component" v-bind:params="modal.params" v-bind:key="i"></component>
    </div>
  </div>
</template>

<script>
const store = require('./store/').default
export default {
  computed: {
    modals: () => {
      return store.getters.modals
    }
  },
  mounted () {
    const newRelicSnippetPath = process.env.VUE_APP_NEW_RELIC_SNIPPET_PATH
    // NewRelicの開発環境は存在しないため、除外
    if (newRelicSnippetPath) {
      this.$loadScript(newRelicSnippetPath)
    }
  }
}
</script>
